import { isElementNode, isTag } from 'anodum';
import { DECORATION_ELEMENT } from '../constants/editable-elements';

const isDecorationElement = (element) => {
  if (!isElementNode(element)) return false;

  return isTag(element, DECORATION_ELEMENT);
};

export default isDecorationElement;
